import { render, staticRenderFns } from "./PersonalChef.vue?vue&type=template&id=3395df29&scoped=true"
import script from "./PersonalChef.vue?vue&type=script&lang=js"
export * from "./PersonalChef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3395df29",
  null
  
)

export default component.exports